import { menuItemHasCurrent } from './SideNav.helpers.js';

export default function MenuItemText({ menuItem }) {
  if (menuItem.slot) return (<>{menuItem.slot}</>);
  if (menuItemHasCurrent(menuItem) && menuItem.activeText) return (<>{menuItem.activeText}</>);
  return (<>{menuItem.text}</>);
}
